import { render } from "./App.vue?vue&type=template&id=3626ba3e"
const script = {}

import "./App.vue?vue&type=style&index=0&id=3626ba3e&lang=scss"

import exportComponent from "/mnt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__